export enum StrategyActionType {
  edit = 'edit',
  duplicate = 'duplicate',
  activate = 'activate',
  publish = 'publish',
  delete = 'delete',
}
